import { DatePicker } from "antd";
import React from "react";
import moment from "moment";
import {
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Row,
  Label,
  Button,
} from "reactstrap";

const AuditTrailContent = ({
  searchBy,
  resetFilter,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  handleFIlter,
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;

  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Search by
                </label>
                <Input
                  id="exampleFormControlSelect1"
                  type="select"
                  style={{ height: "27px" }}
                  value={searchBy}
                  onChange={(e) => {
                    setSearchByValue("");
                    setSearchBy(e.target.value);
                  }}
                >
                  <option value="Email">Email</option>
                  <option value="Action"> Action</option>
                  <option value="ActionOn">Action On</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  Search for
                </label>
                <Input
                  id="example3cols2Input"
                  placeholder={searchByValuePlaceholder}
                  type="text"
                  style={{ height: "27px" }}
                  onKeyPress={(e) => e.charCode === 13 && handleFIlter(true)}
                  onChange={(e) =>
                    setSearchByValue(e.target.value && e.target.value.trim())
                  }
                  value={searchByValue}
                />
              </FormGroup>
            </Col>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  From
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setFromDate(moment(dateString, dateFormat));
                    } else {
                      setFromDate(null);
                    }
                  }}
                  value={fromDate}
                  // format={dateFormat}
                />
              </FormGroup>
            </Col>
            <Col lg="2" className="form-input-padding">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  To
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setToDate(moment(dateString, dateFormat));
                    } else {
                      setToDate(null);
                    }
                  }}
                  value={toDate}
                />
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    type="button"
                    style={{
                      width: "100%",
                      background: "#e91d24",
                      color: "white",
                      height: "26px",
                      border: "1px solid rgb(233, 29, 36)",
                    }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={handleFIlter}
                  >
                    <div>
                      <i class="fas fa-search"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px", padding: "0px 6px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-input-padding col-lg-1"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    color="light"
                    type="button"
                    style={{ width: "100%", height: "26px" }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => resetFilter()}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <i class="fas fa-redo-alt 2px"></i> Reset
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default AuditTrailContent;
